import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Divider, ListItemIcon, ListItemText } from "@mui/material";
import { logout } from "../State/AuthSlice";
import { useAppDispatch } from "../State/Store";

export interface MenuItem {
    name: string;
    path: string;
    icon: React.ReactNode;
    activeIcon: React.ReactNode;
}

interface DrawerListProps {
    menu: MenuItem[];
    menu2: MenuItem[];
    toggleDrawer?: () => void;
}

const DrawerList = ({ menu, menu2, toggleDrawer }: DrawerListProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleItemClick = (path: string) => {
        if (path === "/") {
            dispatch(logout(navigate));
        } else {
            navigate(path);
        }

        if (toggleDrawer) {
            toggleDrawer();
        }
    };

    const renderMenuList = (items: MenuItem[]) => (
        <div className="space-y-2">
            {items.map((item, index: number) => {
                const isActive = item.path === location.pathname;
                return (
                    <div
                        onClick={() => handleItemClick(item.path)}
                        className="pr-9 cursor-pointer"
                        key={index}
                    >
                        <p
                            className={`${
                                isActive
                                    ? "bg-primary-color text-white font-semibold"
                                    : "text-primary-color hover:bg-slate-100"
                            } flex items-center px-5 py-3 rounded-r-full transition-colors duration-150`}
                        >
                            <ListItemIcon>
                                {isActive ? item.activeIcon : item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.name} />
                        </p>
                    </div>
                );
            })}
        </div>
    );

    return (
        <div className="w-[300px] border-r py-5 flex flex-col space-y-4">
            {renderMenuList(menu)}
            <Divider />
            {renderMenuList(menu2)}
        </div>
    );
};

export default DrawerList;